import { useBCMSModal } from "@bcm-dev/bcms-vite";
import BillerView from "compid/shared/views/BillerView";
import UIDropdownButton, { UIDropdownContentItem } from "compid/ui/UIDropdownButton";
import React from "react";
import "./styles.css";

/**
 * @function GroupBillerView
 * @param {STRING} billerGroupName - sets the name of the biller group for the items in the dropdown. 
 * @returns {React.Component}
 * @description This is a variation of the BillerView that allows us to move the biller to different biller groups.
 * @exported true
 * @example
 * <GroupBillerView />
 */
export default function GroupBillerView(props) {
  const { open } = useBCMSModal();
  const biller = props.biller ?? {};
  const billerGroups = props.billerGroups ?? [];
  const billerGroup = biller.billerGroup;
  const billerHasBillerGroup = billerGroup === undefined ? false : true;

  const openModal = obj => () => {
    open("MoveBillerToGroupModal", obj);
  }

  const onMoveGroupButtonModalClick = obj => {
    props.onBillerGroupItemClick(obj);
  }

  // Create "Move" dropdown items.
  const dropdownContentItems = billerGroups.reduce((acc, group) => {
    const itemData = { billerGroup: group, biller: biller, billerID: biller.id, billerGroupToID: group.id, onMoveGroupButtonModalClick: onMoveGroupButtonModalClick };

    // If the biller has a biller group, add all groups except the one its in.
    if(billerHasBillerGroup) {
      if(billerGroup.id !== group.id) {
        itemData.billerGroupTo = group;
        
        acc.push(
          <UIDropdownContentItem key={ group.id } text={ group.name } onClick={ openModal(itemData) } dataPoint={ `Group_Biller_Dropdown_${ group.id }` } />
        );
      }
    // Else, biller is in "Other billers" (placeholder group),
    // so add all groups that are not "Other billers".
    } else if(!group.otherBillers) {
      itemData.billerGroupTo = group;

      acc.push(
        <UIDropdownContentItem key={ group.id } text={ group.name } onClick={ openModal(itemData) } dataPoint={ `Group_Biller_Dropdown_${ group.id }` } />
      );
    }

    return acc;
  }, []);

  // "Other billers" group will always be set by default,
  // so check if we have groups that the user created.
  const buttons = billerGroups.length > 1 ?
  <UIDropdownButton text="Move" dataPoint={ `Group_Biller_Move_${ biller.id }` }>
  { dropdownContentItems }
  </UIDropdownButton>
  : 
  undefined;

  return(
    <BillerView
      className="group-biller-view"
      dataPoint={ `Group_Biller` }
      biller={ biller }
      buttons={ buttons }
    />
  );
}